/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CancelOrderByIdOptions,
  CancelOrderByIdStatus200,
  CancelOrderByIdStatus400,
  CancelOrderByIdStatus401,
  CancelOrderByIdStatus404,
  CancelOrderByIdStatus500,
} from '../types/CancelOrderById'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { cancelOrderById } from '../clients/cancelOrderById'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const cancelOrderByIdMutationKey = () => [{ url: '/v1/orders/:order_id' }] as const

export function cancelOrderByIdMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = cancelOrderByIdMutationKey()
  return mutationOptions<
    CancelOrderByIdStatus200,
    ResponseErrorConfig<
      | CancelOrderByIdStatus400
      | CancelOrderByIdStatus401
      | CancelOrderByIdStatus404
      | CancelOrderByIdStatus500
    >,
    CancelOrderByIdOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return cancelOrderById({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Cancel an order by ID
 * {@link /v1/orders/:order_id}
 */
export function useCancelOrderById<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CancelOrderByIdStatus200,
      ResponseErrorConfig<
        | CancelOrderByIdStatus400
        | CancelOrderByIdStatus401
        | CancelOrderByIdStatus404
        | CancelOrderByIdStatus500
      >,
      CancelOrderByIdOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? cancelOrderByIdMutationKey()

  const baseOptions = cancelOrderByIdMutationOptions(config) as UseMutationOptions<
    CancelOrderByIdStatus200,
    ResponseErrorConfig<
      | CancelOrderByIdStatus400
      | CancelOrderByIdStatus401
      | CancelOrderByIdStatus404
      | CancelOrderByIdStatus500
    >,
    CancelOrderByIdOptions,
    TContext
  >

  return useMutation<
    CancelOrderByIdStatus200,
    ResponseErrorConfig<
      | CancelOrderByIdStatus400
      | CancelOrderByIdStatus401
      | CancelOrderByIdStatus404
      | CancelOrderByIdStatus500
    >,
    CancelOrderByIdOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CancelOrderByIdStatus200,
    ResponseErrorConfig<
      | CancelOrderByIdStatus400
      | CancelOrderByIdStatus401
      | CancelOrderByIdStatus404
      | CancelOrderByIdStatus500
    >,
    CancelOrderByIdOptions,
    TContext
  >
}
